import { useContext } from 'react';
import cx from 'classnames';
import AnnotationContext from "../context/AnnotationContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function LineSubject(_ref) {
  let {
    className,
    x: propsX,
    y: propsY,
    orientation = 'vertical',
    min,
    max,
    stroke = '#222',
    ...restProps
  } = _ref;
  // if props are provided, they take precedence over context
  const annotationContext = useContext(AnnotationContext);
  const lineIsVertical = orientation === 'vertical';
  return /*#__PURE__*/_jsx("line", {
    className: cx('visx-annotation-subject', 'visx-annotation-subject-line', className),
    x1: lineIsVertical ? propsX || annotationContext.x : min,
    x2: lineIsVertical ? propsX || annotationContext.x : max,
    y1: lineIsVertical ? min : propsY || annotationContext.y,
    y2: lineIsVertical ? max : propsY || annotationContext.y,
    fill: "transparent",
    pointerEvents: "none",
    stroke: stroke,
    ...restProps
  });
}